import React, { useEffect, useState } from "react"
import { Modal, Form, Row, Col, Spin } from "antd"
import moment from "moment"
import WarehouseService from "src/services/WarehouseService"
import { SectionCard, SectionTitle } from "../../Modal/styleds" // 🔁 đường dẫn tùy chỉnh

const ModalDetailData = ({ open, onCancel, record }) => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (open && record?.ID) {
      fetchDetailData()
    } else {
      setData(null)
    }
  }, [record])

  const fetchDetailData = async () => {
    setLoading(true)
    try {
      const response = await WarehouseService.getDetailData(record.ID)
      const detail = response?.success || {}
      setData(detail)
    } catch (error) {
      console.error("Lỗi khi lấy chi tiết data:", error)
    } finally {
      setLoading(false)
    }
  }

  const formatDate = date => (date ? moment(date).format("DD/MM/YYYY") : "--")

  const formatNumber = num =>
    !isNaN(num) ? Number(num).toLocaleString() : "--"

  const renderValue = value => <span>{value || "--"}</span>

  return (
    <Modal
      title="Chi tiết kho Data"
      open={open}
      onCancel={onCancel}
      width={1000}
      footer={null}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <Form layout="vertical">
          {/* Thông tin cơ bản */}
          <SectionCard>
            <SectionTitle>Thông tin chung</SectionTitle>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Nhà cung cấp">
                  {renderValue(data?.supplier?.name)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Nhà mạng">
                  {renderValue(data?.network?.name)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Quốc gia">
                  {renderValue(data?.country?.title)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Ngày nhập">
                  {renderValue(formatDate(data?.created_at))}
                </Form.Item>
              </Col>
            </Row>
          </SectionCard>

          {/* Thông tin dung lượng & giá */}
          <SectionCard>
            <SectionTitle>Thông tin dữ liệu</SectionTitle>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Đơn giá data">
                  {renderValue(`${formatNumber(data?.unit_price)}`)}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Dung lượng data">
                  {renderValue(formatNumber(data?.total_data))}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Data sử dụng">
                  {renderValue(formatNumber(data?.data_used))}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Data còn lại">
                  {renderValue(formatNumber(data?.data_remaining))}
                </Form.Item>
              </Col>
            </Row>
          </SectionCard>

          {/* Chiết khấu */}
          <SectionCard>
            <SectionTitle>Thông tin chiết khấu</SectionTitle>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Loại chiết khấu">
                  {renderValue(
                    data?.discount_type === "percent"
                      ? "Chiết khấu %"
                      : data?.discount_type,
                  )}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Chiết khấu">
                  {renderValue(Number(data?.discount || 0).toLocaleString())}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item label="Tổng tiền">
                  {renderValue(formatNumber(data?.total_amount))}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Thành tiền sau chiết khấu">
                  {renderValue(formatNumber(data?.total_discord))}
                </Form.Item>
              </Col>
            </Row>
          </SectionCard>

          {/* Gói cước */}
          {/* <SectionCard>
            <SectionTitle>Gói cước</SectionTitle>
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item label="Gói cước đang dùng">
                  {renderValue(
                    data?.dataPlan
                      ? `${data.dataPlan} (${data?.dataPlanUsage || 0} GB)`
                      : "--",
                  )}
                </Form.Item>
              </Col>
            </Row>
          </SectionCard> */}
        </Form>
      </Spin>
    </Modal>
  )
}

export default ModalDetailData
